import Layout from '../../layout/Dashboard';

import Button from '../../components/Button';
import Loading from '../../components/Loading';
import Heading from '../../components/Heading';
import Dropdown from '../../components/Dropdown';
import * as InputStyles from '../../components/Input/Input.styles';
import useNewsStockMarket from '../../hooks/useNewsStockMarket';
import DateDropdown from '../Admin/News/components/DateDropdown';

import List from './components/List';
import * as Styles from './NewsStockMarket.styles';

export default function NewsStockMarket() {
  const {
    isNewsLoading,
    totalPage,
    currentPage,
    news,
    isNewsSourceLoading,
    newsSource,
    selectedNewsSource,
    handleNewsSourceChange,
    keyword,
    setKeyword,
    publishedAt,
    startDate,
    endDate,
    handleDateChange,
    handleFilter,
    handlePageChange,
    handleToggleSource,
    toggleSource,
  } = useNewsStockMarket();

  const handleInputChange = (event) => {
    setKeyword(event.target.value);
  };

  return (
    <Layout>
      <Styles.Wrapper>
        <div className="flex justify-between items-center flex-col slg:flex-row relative z-10">
          <div className="flex items-center">
            <Heading classNames="mb-0 page-title">
              Tin thị trường chứng khoán
            </Heading>
          </div>
          <div className="mt-4 md:mt-0 relative">
            <Loading isLoading={isNewsSourceLoading} className="white" />
            <div className="flex justify-end items-center news-filter">
              <div className="mr-2 relative w-48">
                <InputStyles.TextField
                  name="searchNews"
                  placeholder="Tìm kiếm"
                  onChange={handleInputChange}
                  value={keyword}
                />
              </div>
              <div className="mr-2 relative w-48 z-30">
                <DateDropdown
                  startDate={startDate}
                  endDate={endDate}
                  onChange={handleDateChange}
                  maxDate={new Date(Number(publishedAt))}
                />
              </div>
              <div className="mr-2 relative w-48 source">
                <Dropdown
                  options={newsSource.map((s) => ({
                    ...s,
                    label: s.label,
                  }))}
                  defaultOption={selectedNewsSource}
                  onChange={handleNewsSourceChange}
                  clearIcon={null}
                />
              </div>
              <div className="w-auto">
                <Button onClick={handleFilter}>Lọc</Button>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5 relative z-0">
          <List
            isLoading={isNewsLoading}
            news={news}
            totalPage={totalPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            handleToggleSource={handleToggleSource}
            toggleSource={toggleSource}
          />
        </div>
      </Styles.Wrapper>
    </Layout>
  );
}
